import React from "react";
import { Button, Form } from "react-bootstrap";
import { WizardFormData } from "./types";

const StepDisplayOptions: React.FC<{
  formData: WizardFormData;
  onChange: (updates: Partial<WizardFormData>) => void;
  onBack: () => void;
  onNext: () => void;
}> = ({ formData, onChange, onBack, onNext }) => (
  <div className="wizard-card">
    <div className="wizard-header">Display Options</div>
    <div className="wizard-description">
      Choose what information is visible on your public listing.
    </div>

    <div className="radio-group">
      <div className="radio-group-label">Revenue</div>
      <Form.Check
        type="radio"
        id="revenue-trendline"
        label="Show trendline"
        name="revenueDisplay"
        checked={formData.revenueDisplay === "trendline"}
        onChange={() => onChange({ revenueDisplay: "trendline" })}
      />
      <Form.Check
        type="radio"
        id="revenue-trendline-amounts"
        label="Show trendline with amounts"
        name="revenueDisplay"
        checked={formData.revenueDisplay === "trendline-with-amounts"}
        onChange={() => onChange({ revenueDisplay: "trendline-with-amounts" })}
      />
      <Form.Check
        type="radio"
        id="revenue-hidden"
        label="Don't show"
        name="revenueDisplay"
        checked={formData.revenueDisplay === "hidden"}
        onChange={() => onChange({ revenueDisplay: "hidden" })}
      />
    </div>

    <div className="radio-group">
      <div className="radio-group-label">Subscriptions</div>
      <Form.Check
        type="radio"
        id="subscriptions-trendline"
        label="Show trendline"
        name="subscriptionsDisplay"
        checked={formData.subscriptionsDisplay === "trendline"}
        onChange={() => onChange({ subscriptionsDisplay: "trendline" })}
      />
      <Form.Check
        type="radio"
        id="subscriptions-trendline-amounts"
        label="Show trendline with amounts"
        name="subscriptionsDisplay"
        checked={formData.subscriptionsDisplay === "trendline-with-amounts"}
        onChange={() =>
          onChange({ subscriptionsDisplay: "trendline-with-amounts" })
        }
      />
      <Form.Check
        type="radio"
        id="subscriptions-hidden"
        label="Don't show"
        name="subscriptionsDisplay"
        checked={formData.subscriptionsDisplay === "hidden"}
        onChange={() => onChange({ subscriptionsDisplay: "hidden" })}
      />
    </div>

    <div className="radio-group">
      <div className="radio-group-label">Customer Country Distribution</div>
      <Form.Check
        type="radio"
        id="country-top3"
        label="Show top 3 countries"
        name="countryDisplay"
        checked={formData.countryDisplay === "top3"}
        onChange={() => onChange({ countryDisplay: "top3" })}
      />
      <Form.Check
        type="radio"
        id="country-top10"
        label="Show top 10 countries"
        name="countryDisplay"
        checked={formData.countryDisplay === "top10"}
        onChange={() => onChange({ countryDisplay: "top10" })}
      />
      <Form.Check
        type="radio"
        id="country-hidden"
        label="Don't show"
        name="countryDisplay"
        checked={formData.countryDisplay === "hidden"}
        onChange={() => onChange({ countryDisplay: "hidden" })}
      />
    </div>

    <div className="wizard-nav">
      <Button variant="outline-secondary" onClick={onBack}>
        Back
      </Button>
      <Button variant="primary" onClick={onNext}>
        Next
      </Button>
    </div>
  </div>
);

export default StepDisplayOptions;
